import src from "IMAGE";
export default { src, width: 418, height: 241, blurWidth: 0, blurHeight: 0};
